import React from 'react';

import { Box, Divider } from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';

import HeaderChargesPending from './components/header';
import ListSubscriptions from './components/list';
import NotificationModal from '../components/notificationModal';

function Subscriptions() {
  const toggle = useToggle('new_ds_subscriptions');

  if (!toggle) { return (<NotificationModal />); }

  return (
    <Box mb={10}>
      <HeaderChargesPending />

      <Divider />

      <ListSubscriptions />
    </Box>
  );
}

export default Subscriptions;
